(function ($) {
 "use strict";
 
   jQuery(document).ready(function(){
     
     $('span.mega_menu_list').parent('div').addClass('mega-menu');
         /*----------------------------
        jQuery MeanMenu
    ------------------------------ */
	jQuery('nav#dropdown').meanmenu();	
     
    
     $('.product-height').matchHeight(); 
     
    /*----------------------------
         Elevate Zoom active
    ------------------------------ */
     $("#zoom1").elevateZoom({
       cursor: 'pointer',
       gallery:'gallery_01',
       galleryActiveClass: "active",       
       lensSize: 200,
       zoomWindowWidth: 400,
       zoomWindowHeight: 400,
       imageCrossfade: true
     });     
     
     
     
/* Header Top JS */
	$(".search-icon").on('click', function(){
        $(".header-bottom-search").slideToggle();
		$(".first-currencies").css("display","none");
		$(".first-languages").css("display","none");
    });
 
 /* Search Letter */
	jQuery("#search-letter").on('focus', function(){
		if(jQuery(this).val()=="Enter your e-mail"){
			jQuery(this).val("");
		}
	});
	jQuery("#search-letter").on('focusout', function(){
		if(jQuery(this).val()==""){
			jQuery(this).val("Enter your e-mail");
		}
	});
	jQuery("#header-letter-btn").on("click", function(){
		if(jQuery("#search-letter").val()=="Enter your e-mail" || jQuery("#search-letter").val()==""){
			jQuery("#search-letter").on('focus');
			return false;
		}
	}); 
 
 /*----------------------------
	owl active Featured products 
------------------------------ */  
  $(".featured-product-list, .product_img_list").owlCarousel({
      autoPlay: false, 
	  slideSpeed:2000,
	  pagination:false,
	  navigation:true,	  
      items : 4,
	  /* transitionStyle : "fade", */    /* [This code for animation ] */
	  navigationText:["<i class='fa fa-angle-double-left'></i>","<i class='fa fa-angle-double-right'></i>"],
      itemsDesktop : [1199,4],
	  itemsDesktopSmall : [991,3],
	  itemsTablet: [767,2],
	  itemsMobile: [479,2]
	  // itemsMobile: [479,1]
  });
    
 /*----------------------------
	owl active Featured products 
------------------------------ */  
  $(".featured-product-list2").owlCarousel({
      autoPlay: false, 
	  slideSpeed:2000,
	  pagination:false,
	  navigation:true,	  
      items : 3,
	  /* transitionStyle : "fade", */    /* [This code for animation ] */
	  navigationText:["<i class='fa fa-angle-double-left'></i>","<i class='fa fa-angle-double-right'></i>"],
      itemsDesktop : [1199,3],
	  itemsDesktopSmall : [991,3],
	  itemsTablet: [767,2],
	  itemsMobile: [479,2]
	  // itemsMobile: [479,1]
  });
  
 /*----------------------------
	owl active Deal products 
------------------------------ */  
  $(".deal-area-list").owlCarousel({
      autoPlay: false, 
	  slideSpeed:2000,
	  pagination:true,
	  navigation:false,	  
      items : 2,
      itemsDesktop : [1199,2],
	  itemsDesktopSmall : [991,1],
	  itemsTablet: [767,1],
	  itemsMobile: [479,1]
  });
    
 /*----------------------------
	owl active Testimonial 
------------------------------ */  
  $(".testimonial-list").owlCarousel({
      autoPlay: false, 
	  slideSpeed:2000,
	  pagination:true,
	  navigation:false,	  
      singleItem : true
  });
    
  /*----------------------------
	owl active Brand Area 
------------------------------ */  
  $(".brand-list").owlCarousel({
      autoPlay: false, 
	  slideSpeed:2000,
	  pagination:false,
	  navigation:false,	  
      items : 6,
      itemsDesktop : [1199,6],
	  itemsDesktopSmall : [991,4],
	  itemsTablet: [767,3],
	  itemsMobile: [479,2]
  });
    
  /*----------------------------
	owl active Blog Area 
------------------------------ */  
  $(".blog-list").owlCarousel({
      autoPlay: false, 
	  slideSpeed:2000,
	  pagination:false,
	  navigation:true,	  
      items : 3,
	  /* transitionStyle : "fade", */    /* [This code for animation ] */
	  navigationText:["<i class='fa fa-angle-double-left'></i>","<i class='fa fa-angle-double-right'></i>"],
      itemsDesktop : [1199,3],
	  itemsDesktopSmall : [991,3],
	  itemsTablet: [767,1],
	  itemsMobile: [479,1]
  });

     //---------------------------------------------
     //Nivo slider
     //---------------------------------------------
     $('#ensign-nivoslider-3').nivoSlider({
       effect: 'boxRainGrowReverse',
       slices: 15,
       boxCols: 8,
       boxRows: 4,
       animSpeed: 500,
       pauseTime: 3000,
       startSlide: 0,
       directionNav: true,
       controlNavThumbs: false,
       pauseOnHover: true,
       manualAdvance: false
     });      
/*---------------------
 countdown
--------------------- */
	$('[data-countdown]').each(function() {
	  var $this = $(this), finalDate = $(this).data('countdown');
	  $this.countdown(finalDate, function(event) {
		$this.html(event.strftime('<span class="cdown days"><span class="time-count">%-D</span> <p>Days</p></span> <span class="cdown hour"><span class="time-count">%-H</span> <p>Hour</p></span> <span class="cdown minutes"><span class="time-count">%M</span> <p>Min</p></span> <span class="cdown second"> <span><span class="time-count">%S</span> <p>Sec</p></span>'));
	  });
    });	 
/*---------------------
   scrollUp
--------------------- */	
	$.scrollUp({
        scrollText: '<i class="fa fa-arrow-up"></i>',
        easingType: 'linear',
        scrollSpeed: 1000,
        animation: 'fade'
    });	


	 
/*--------------------------------
	Create an account toggle function
---------------------------------*/
	$( '#cbox' ).on('click', function() {
		$( '#cbox_info' ).slideToggle(900);
	});
 
/*---------------------------------
	Create an account toggle function
---------------------------------*/
	$( '#ship-box' ).on('click', function() {
		$( '#ship-box-info' ).slideToggle(1000);
	});	

/* ---------------------------------
	payment-accordion
* ---------------------------------*/ 
	$(".payment-accordion").collapse({
		accordion:true,
		open: function() {
		this.slideDown(550);
		},
		close: function() {
		this.slideUp(550);
		}		
	});
	

 
/*----------------------------
	Input Plus Minus Button
------------------------------ */ 
    $(".cart-plus-minus").append('<div class="dec qtybutton">-</div><div class="inc qtybutton">+</div>');
    $(".qtybutton").on("click", function() {
        var $button = $(this);
        var oldValue = $button.parent().find("input").val();
        if ($button.text() == "+") {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 0) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }
        }
        $button.parent().find("input").val(newVal);
    });
	


     
     
     
     
     
	  });
  
  
  
  
 
})(jQuery); 